import { call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  GET_CRS_CUSTOMER_LIST_DATA,
  GET_CRS_SEGMENT_LIST_DATA,
  GET_CRS_CLUSTER_LIST_DATA,
  GET_CRS_CUSTOMER_TYPE_LIST_DATA,
  GET_CRS_RISK_LEVEL_CHANGE_LIST_DATA,
  getCrsCustomerListDataSuccess,
  getCrsCustomerListDataFail,
  getCrsSegmentListDataSuccess,
  getCrsSegmentListDataFail,
  getCrsClusterListDataSuccess,
  getCrsClusterListDataFail,
  getCrsCustomerTypeListDataFail,
  getCrsCustomerTypeListDataSuccess,
  getCrsRiskLevelChangeListDataSuccess,
  getCrsRiskLevelChangeListDataFail
} from '../../redux/actions/crs/crsListView';
import * as api from '../../services/crs/crsListView';

import { CRS_CONSTANTS } from '../../pages/constants/crsContants';

const networkLayerObject = new api.NetworkLayer();

function* getCustomerListDataWorker(payload) {
  try {
    const response = yield call(networkLayerObject.customerListAPI, payload);
    console.log('response', response);
    yield put(getCrsCustomerListDataSuccess(response));
  } catch (error) {
    yield put(getCrsCustomerListDataFail({ error: '' }));
  }
}

export function* watchGetCustomerListData() {
  yield takeEvery(GET_CRS_CUSTOMER_LIST_DATA, function* ({ payload }) {
    yield fork(getCustomerListDataWorker, payload);
  });
}

function* getSegmentListDataWorker(payload) {
  try {
    const response = yield call(networkLayerObject.segmentListAPI, payload);
    yield put(getCrsSegmentListDataSuccess(response));
  } catch (error) {
    yield put(getCrsSegmentListDataFail({ error: '' }));
  }
}

export function* watchGetSegmentListData() {
  yield takeEvery(GET_CRS_SEGMENT_LIST_DATA, function* ({ payload }) {
    yield fork(getSegmentListDataWorker, payload);
  });
}

function* getClusterListDataWorker(payload) {
  try {
    const response = yield call(networkLayerObject.clusterListAPI, payload);
    yield put(getCrsClusterListDataSuccess(response));
  } catch (error) {
    yield put(getCrsClusterListDataFail({ error: '' }));
  }
}

export function* watchGetClusterListData() {
  yield takeEvery(GET_CRS_CLUSTER_LIST_DATA, function* ({ payload }) {
    yield fork(getClusterListDataWorker, payload);
  });
}

function* getCustomerTypeListDataWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.customerTypeListAPI,
      payload
    );
    yield put(getCrsCustomerTypeListDataSuccess(response));
  } catch (error) {
    yield put(getCrsCustomerTypeListDataFail({ error: '' }));
  }
}

export function* watchGetCustomerTypeListData() {
  yield takeEvery(GET_CRS_CUSTOMER_TYPE_LIST_DATA, function* ({ payload }) {
    yield fork(getCustomerTypeListDataWorker, payload);
  });
}

function* getRiskLevelChangeListDataWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.riskLevelChangeListAPI,
      payload
    );
    yield put(getCrsRiskLevelChangeListDataSuccess(response));
  } catch (error) {
    yield put(getCrsRiskLevelChangeListDataFail({ error: '' }));
  }
}

export function* watchGetRiskLevelChangeListData() {
  yield takeEvery(GET_CRS_RISK_LEVEL_CHANGE_LIST_DATA, function* ({ payload }) {
    yield fork(getRiskLevelChangeListDataWorker, payload);
  });
}
